import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import UserAvatar from "../../common/UserAvatar";
import Username from "../../common/Username";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCogs, faExclamationTriangle, faFlag, faImage, faTools, faUserCircle } from "@fortawesome/free-solid-svg-icons";
import { MenuItem } from "@szhsin/react-menu";
import PopupMenu from "../../common/PopupMenu";
import { AuthContext } from "../../../context/authContext";
import { boardUrl } from "../../../config/config";
import { Tooltip } from "react-tooltip";

const ActionItems = ({ user }) => {
	const { visitor } = useContext(AuthContext);

	const actions = [
		{
			title: "Sửa",
			icon: <FontAwesomeIcon icon={faCogs} />,
			url: `${user.view_url}edit`,
			display: user.can_edit,
		},
		{
			title: "Cập nhật avatar",
			icon: <FontAwesomeIcon icon={faUserCircle} />,
			url: `${user.view_url}account/avatar`,
			display: user.is_visitor,
		},
		{
			title: "Cập nhật ảnh bìa",
			icon: <FontAwesomeIcon icon={faImage} />,
			url: `${user.view_url}account/banner`,
			display: user.is_visitor,
		},
		{
			title: "Báo cáo",
			icon: <FontAwesomeIcon icon={faFlag} />,
			url: `${user.view_url}report`,
			display: user.can_report,
		},
		{
			title: "Cảnh cáo",
			icon: <FontAwesomeIcon icon={faExclamationTriangle} />,
			url: `${user.view_url}warn`,
			display: user.can_warn,
		},
		{
			title: "Ban",
			icon: <FontAwesomeIcon icon={faFlag} />,
			url: `${user.view_url}ban`,
			display: user.can_ban,
		},
	];

	return (
		<>
			{actions.map((item, index) => {
				if (item.display) {
					return (
						<MenuItem key={index} href={item.url}>
							<span className="inline-block mr-2">{item.icon}</span>
							<span>{item.title}</span>
						</MenuItem>
					);
				}
			})}
		</>
	);
};

const HeroSection = ({ user, userData, toggleFollowing, badges }) => {
	const { t } = useTranslation();

	if (user) {
		return (
			<div className="relative bg-primary px-4 py-20 overflow-hidden">
				{user.profile_banner_urls.l && (
					<div className="absolute -top-10 -bottom-10 -left-10 -right-10 blur-sm brightness-[0.6] z-5">
						<img src={user.profile_banner_urls.l} alt={user.username} className="w-full h-full object-cover" />
					</div>
				)}

				<div className="absolute inline-block top-5 right-5 z-20">
					<PopupMenu
						label={
							<div className="inline-flex bg-secondary bg-opacity-65 p-2 rounded items-center gap-x-2 text-sm text-white">
								<FontAwesomeIcon icon={faTools} />
								<span>Công cụ</span>
							</div>
						}
					>
						<div className="szh-menu-container-background">
							<ActionItems user={user} />
						</div>
					</PopupMenu>
				</div>

				<div className="relative flex flex-col items-center z-10">
					<div className="mb-4 w-24 h-24 p-1 ring-4 ring-url rounded-full">
						<UserAvatar user={user} />
					</div>

					<h1 className="text-2xl mb-4">
						<Username user={user} />
					</h1>

					<div className="mb-2 flex items-center gap-x-2">
						<Tooltip id="badge-tooltip" />

						{badges.map((badge, index) => (
							<img
								key={index}
								src={`${boardUrl}/${badge.Badge.image_url}`}
								alt={badge.Badge.title_html}
								className="w-[30px] h-[30px]"
								data-tooltip-id="badge-tooltip"
								data-tooltip-content={badge.Badge.title_html}
							/>
						))}
					</div>

					{userData && (
						<div className="mb-2 flex items-center gap-x-2">
							{user.can_follow && (
								<button onClick={toggleFollowing} className="button button--cta">
									{userData.following ? "Bỏ theo dõi" : "Theo dõi"}
								</button>
							)}

							{user.can_ignore && (
								<a href={`${user.view_url}/ignore`} className="button button--cta">
									Phớt lờ
								</a>
							)}

							{user.can_converse && (
								<a href={`${boardUrl}/index.php?direct-messages/add&to=${user.username}`} className="button button--cta">
									Gửi tin nhắn
								</a>
							)}
						</div>
					)}

					<div className="text-white mb-2">
						<span className="bg-secondary text-white text-sm me-2 px-2.5 py-0.5 rounded">{user.user_title}</span>
						<span>{t("join_date")}: {user.register_date}</span>
					</div>

					<div className="text-white">
						<span>{t("posts")}: <b>{user.message_count}</b></span>
						<span className="ml-2">{t("reaction_score")}: <b>{user.reaction_score}</b></span>
						<span className="ml-2">{t("followers")}: <b>{user.follower_count}</b></span>
					</div>
				</div>
			</div>
		);
	}

	return null;
};

export default HeroSection;
